// Which desktop the browser is running on, and where that desktop's Medsender
// Printer Driver installer lives. The driver ships as a Windows installer and a
// Mac disk image, each at its own URL (baked in by rspack's DefinePlugin), so
// every "Install Printer Driver" button in the app resolves the link through
// here rather than assuming Windows.

const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
const macPlatforms = ['MacIntel', 'MacPPC', 'Mac68K', 'Macintosh'];

export const PRINTER_DRIVER_PLATFORMS = {
  windows: 'windows',
  mac: 'mac',
};

// Windows XP (NT 5.1) cannot run the installer.
export const isSupportedWindowsDevice = (navigatorObject = window.navigator) => (
  windowsPlatforms.indexOf(navigatorObject.platform) !== -1
  && (navigatorObject.userAgent || '').indexOf('Windows NT 5.1') === -1
);

// iPadOS Safari presents itself as a Mac (MacIntel platform, Macintosh user
// agent); the only reliable tell is that it reports touch points.
export const isSupportedMacDevice = (navigatorObject = window.navigator) => (
  macPlatforms.indexOf(navigatorObject.platform) !== -1
  && !(navigatorObject.maxTouchPoints > 1)
);

export const printerDriverPlatform = (navigatorObject = window.navigator) => {
  if (isSupportedWindowsDevice(navigatorObject)) return PRINTER_DRIVER_PLATFORMS.windows;
  if (isSupportedMacDevice(navigatorObject)) return PRINTER_DRIVER_PLATFORMS.mac;
  return null;
};

export const isPrinterDriverSupportedDevice = (navigatorObject = window.navigator) => (
  printerDriverPlatform(navigatorObject) !== null
);

export const printerDriverDownloadLink = (navigatorObject = window.navigator) => {
  switch (printerDriverPlatform(navigatorObject)) {
    case PRINTER_DRIVER_PLATFORMS.windows:
      return process.env.DOWNLOAD_APP_LINK;
    case PRINTER_DRIVER_PLATFORMS.mac:
      return process.env.DOWNLOAD_MAC_APP_LINK;
    default:
      return null;
  }
};

// Opens the installer for the current desktop in a new tab. Returns the opened
// window, or null when the device has no installer or the popup was blocked.
export const openPrinterDriverDownload = (navigatorObject = window.navigator) => {
  const link = printerDriverDownloadLink(navigatorObject);
  if (!link) return null;
  const win = window.open(link, '_blank');
  if (win) win.opener = null;
  return win;
};
